class ctxDropdownTrigger {
    constructor($timeout) {
        this.restrict = 'E';
        this.transclude = true;
        this.require = '^ctxDropdown';
        this.template = '<ng-transclude/>';
        this.$timeout = $timeout;
    }

    link(scope, element, attrs, ctxDropdown) {
        element.attr('data-toggle', 'dropdown');
        element.attr('aria-haspopup', 'true');
        element.attr('aria-expanded', 'true');

        this.$timeout(() => {
            element.attr('id', ctxDropdown.dropdownId);
            const ctxDropdownListCtrl = scope.ctxDropdownListCtrl;
        }, 0);
    }

    static directiveFactory($timeout) {
        return new ctxDropdownTrigger($timeout);
    }
}

ctxDropdownTrigger.directiveFactory.$inject = ['$timeout'];

module.exports = ctxDropdownTrigger.directiveFactory;



// WEBPACK FOOTER //
// ./src/shared/ctxDropdown/ctxDropdownTrigger.directive.js